import React from "react";
import Marquee from "react-fast-marquee";

const Hero: React.FC = () => {
    return (
        <section className="hero hero--background" >
            <div className="hero__wrapper">
                <div className="hero__container">
                <h1 className="h1 hero__title">
                    Iggy Dance & <span className="hero__title-separator"/>DJ Challenge!
                </h1>
                <span className="hero__subtitle">season 1</span>
                </div>
                
            </div>

            <span className="circle-effect-1" aria-label="circle effect"/>
            <span className="circle-effect-3" aria-label="circle effect"/>
            <span className="circle-effect-5" aria-label="circle effect"/>
        </section>
    );
};

export default Hero;